// extracted by mini-css-extract-plugin
module.exports = {"Header":"TShirtsStockingHeader_Header__XmB3n","SizeSelected":"TShirtsStockingHeader_SizeSelected__32Ad3"};